import { ICrop } from "./crops"
import { ICropping, IField } from "./fields"
import { CropId, FieldAreaType } from "./generated/enums"
import { getDistinctValues } from "./utils/array"
import { checkDateIntersection } from "./utils/date"
import { isNumber } from "./utils/utils"

export interface INtrReqNutrients {

    RequiredN?: number;
    RequiredSO3: number;
    RequiredP2O5?: number;
    RequiredK2O?: number;
    RequiredMgO?: number;
    RequiredLime?: number;

}


export interface INMaxCropping {

    CroppingId: number;

    NMaxDefault?: number;
    NMaxAdjusted?: number;

    NMaxAdjYield?: number;
    NMaxAdjMilling?: number;

    NMaxAdjShallowSoil?: number;
    NMaxAdjGrassCuts?: number;
    NMaxAdjGrassDehydration?: number;
    NMaxAdjStrawMulch?: number;
    NMaxAdjPaperWaste?: number;

    NMaxAdjYieldOver4Tons?: number;
    NMaxAdjHighNDistilling?: number;

}

export interface INMaxCropGroup {

    HoldingId: number;
    YearId: number;

    GroupId: number;
    CropId: number;

    NMaxDefault: number;
    NMaxAverage: number;
    NRequiredAverage?: number;
    NAppliedAverage?: number;

    Cropping: INMaxCropping[];

}

const ignoredCrops: CropId[] = [
    0,
    CropId.GrassMargin,
    CropId.OutdoorPigs,
    CropId.OutdoorPoultry,
    CropId.EFA,
    CropId.Fallow,
    CropId.NonFarmedArea,
    CropId.Woodland
]

export function isCropSupportedForNutrition(crop: { crop: ICrop, cropId: number }) {

    if (!crop) {
        return false
    }

    if (crop.crop && crop.crop.Hidden) {
        return false
    }

    switch (crop.cropId || 0) {

        case 0:
        case CropId.NonFarmedArea:
        case CropId.Woodland:
            return false

        default:
            return true

    }

}

export function isCropIgnoredForNutrition(cropId: number) {
    return ignoredCrops.indexOf(cropId || 0) >= 0;
}

export function getManureSpreadableArea(cropping: ICropping, defaultToCroppingArea: boolean = true): number {

    if (isNumber(cropping.ManureSpreadArea) && (cropping.ManureSpreadArea >= 0)) {
        return cropping.ManureSpreadArea;
    }

    let defaultValue = defaultToCroppingArea ? cropping.Area : null;

    if (!isNumber(cropping.Field.ManureSpreadArea)) {
        return defaultValue;
    }

    if (cropping.Area !== getEffectiveCroppingArea(cropping.Field)) {
        return defaultValue;
    }

    var fieldCropping = cropping.Field.Cropping.filter(c => c.YearId === cropping.YearId);

    var concurrent = fieldCropping.filter(c => c.CroppingId !== cropping.CroppingId && checkDateIntersection(c.StartDate, c.EndDate, cropping.StartDate, cropping.EndDate));

    if (concurrent.length > 0) {
        return defaultValue;
    }

    return cropping.Field.ManureSpreadArea;
}

function getEffectiveCroppingArea(field: IField) {

    if (field.AreaType === FieldAreaType.BoundaryArea) {
        return field.BoundaryArea;
    }

    if (field.AreaType === FieldAreaType.WorkingArea) {
        return field.WorkingArea;
    }

    return field.WholeArea;
}

export function getMainCropForNmaxGroup(cropping: { Crop: ICrop, Area: number }[]): ICrop {

    cropping = cropping.filter(c => !!c.Crop);

    if (!cropping.length) {
        return null;
    }

    if (cropping.every(c => c.Crop.Grass)) {

        return cropping.sort((c1, c2) => c2.Area - c1.Area)[0].Crop;

    }
    else {

        let crops = getDistinctValues(cropping.map(c => c.Crop), c => c, c => c ? c.CropId : 0);

        if (crops.length == 1) {
            return cropping[0].Crop;
        }

    }


}
